import { defineAdapter } from "@repo/adapter-core";
import {
  REALESTATE_DEFAULT_CONFIG,
  RealestateAdapterConfigSchema,
  resolveRealestateConfig,
} from "./config.ts";
import { REALESTATE_ADAPTER_META } from "./meta.ts";
import { buildPaginatedUrl, buildSearchUrl } from "./runtime.ts";
import { detectReaBotResponse, parseReaDetailHtml, parseReaDiscoveryPreviews } from "./parser.ts";
import { extractReaAssets } from "./assets.ts";

export * from "./assets.ts";
export * from "./config.ts";
export * from "./meta.ts";
export * from "./runtime.ts";
export * from "./parser.ts";

export const REALESTATE_ADAPTER = defineAdapter({
  meta: REALESTATE_ADAPTER_META,
  defaultConfig: REALESTATE_DEFAULT_CONFIG,
  resolvedConfigSchema: RealestateAdapterConfigSchema,
  resolveConfig: resolveRealestateConfig,
  buildSearchUrl,
  // Search URLs can list sold, for-sale or rental listings: each is its own discovery lane.
  listingTypes: ["buy", "sold", "rent"],
  // A job set to Any crawls for-sale and sold, so a for-sale listing can be followed until it sells.
  anyListingTypes: ["buy", "sold"],
  buildPaginatedUrl,
  // REA's sold-listings URL does NOT support a query-string date filter. Each search card carries
  // its sold date (2026-10-28, from stored discovery snapshots), which restores the discovery-stage
  // date guard; only the suburb's own (exact) results are read, never the surrounding-suburb padding.
  parseDiscoveryPreviews: parseReaDiscoveryPreviews,
  // For-sale searches record each card as a listing and fetch no detail page (follow-until-sold
  // option B), like Domain.
  listingCards: true,
  parseDetailHtml: parseReaDetailHtml,
  detectBotResponse: detectReaBotResponse,
  // Search pages only. Detail pages go Firecrawl-first: on 2026-09-25 Bright Data-first REA detail
  // scrapes drew 223 bot pages in an hour, the low success rate got our zone throttled to 10/min,
  // while Firecrawl returned 227 of 398 REA records.
  brightdataDiscoveryFirst: true,
  // 2026-09-26: Zyte returned 503 on 555 REA detail pages in one hour. No brightdataOverflow: Bright
  // Data served 10 of 196 REA detail pages (bot-detection pages, reject_block).
  zyteBlocked: true,
  extractAssets: extractReaAssets,
});
